const SHIFT_VALUE = 5;

export function generateRandomString(): string {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ123456789';
    let result = '';
    for (let i = 0; i < 6; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        result += chars[randomIndex];
    }
    return result;
}

function createHash(input: string): string {
    let hash = '';
    for (let i = 0; i < input.length; i++) {
        hash += String.fromCharCode(input.charCodeAt(i) + SHIFT_VALUE);
    }
    return hash;
}

function removeSeedWord(input: string, seedWord: string): string {
    const seedHash = createHash(seedWord);
    return input.startsWith(seedHash) ? input.slice(seedHash.length) : input;
}

export function undoSeededHash(hash: string, seedWord: string): string {
    // Remove the seed hash part from the beginning of the hash
    const strippedHash = removeSeedWord(hash, seedWord);
    
    // Decode the remaining part of the hash
    let original = '';
    for (let i = 0; i < strippedHash.length; i++) {
        original += String.fromCharCode(strippedHash.charCodeAt(i) - SHIFT_VALUE);
    }
    return original;
}

export function createSeededHash(seedWord: string, otherWord: string): string {
    return createHash(seedWord + otherWord);
}

export function checkSeededHash(hash: string, seedWord: string, wordToCheck: string): boolean {
    const calculatedHash = createSeededHash(seedWord, wordToCheck);
    return calculatedHash === hash;
}
